import {
  collection,
  doc,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
  type Unsubscribe,
} from 'firebase/firestore'
import { firestore } from './db'
import type { Chat, ChatReads, Message } from './types'

// ÚNICOS listeners permitidos (realtime-y-reglas.md): bandeja de chats (solo con /chat
// visible), mensajes del chat abierto, doc padre de notificaciones y chatReads propio.
// permission-denied = "ya no eres miembro": cerrar, no reintentar (G-7).

function guard(onDenied?: () => void) {
  return (err: unknown) => {
    const code = (err as { code?: string }).code
    if (code === 'permission-denied') onDenied?.()
    else console.error('listener error:', err)
  }
}

export function subscribeChats(
  email: string,
  cb: (chats: Chat[]) => void,
  onDenied?: () => void,
): Unsubscribe {
  const q = query(
    collection(firestore, 'chats'),
    where('members', 'array-contains', email),
    where('isActive', '==', true),
    orderBy('lastMessage.at', 'desc'),
    limit(30), // índice #5
  )
  return onSnapshot(q, (snap) => cb(snap.docs.map((d) => d.data() as Chat)), guard(onDenied))
}

export function subscribeMessages(
  chatId: string,
  cb: (messages: Message[]) => void,
  onDenied?: () => void,
): Unsubscribe {
  const q = query(
    collection(firestore, `chats/${chatId}/messages`),
    orderBy('at', 'desc'),
    limit(50),
  )
  return onSnapshot(
    q,
    (snap) => cb(snap.docs.map((d) => d.data() as Message).reverse()),
    guard(onDenied),
  )
}

export function subscribeChatReads(email: string, cb: (reads: ChatReads | null) => void): Unsubscribe {
  return onSnapshot(
    doc(firestore, `chatReads/${email}`),
    (snap) => cb(snap.exists() ? (snap.data() as ChatReads) : null),
    guard(),
  )
}

export function subscribeNotifBadge(email: string, cb: (unread: number) => void): Unsubscribe {
  return onSnapshot(
    doc(firestore, `notifications/${email}`),
    (snap) => cb(snap.exists() ? ((snap.data() as { unreadCount?: number }).unreadCount ?? 0) : 0),
    guard(),
  )
}
